import { render } from "./TextControl.vue?vue&type=template&id=c8c76ee4&scoped=true"
import script from "./TextControl.vue?vue&type=script&lang=js"
export * from "./TextControl.vue?vue&type=script&lang=js"

import "./TextControl.vue?vue&type=style&index=0&id=c8c76ee4&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c76ee4"]])

export default __exports__